import React from "react";
import ReactDOM from "react-dom";
import { StyledEngineProvider } from "@mui/material";

import App from "./App";
import packageJson from "../package.json";
import AppErrorBoundary from "./error-boundary";
import "./index.css";
import { LocalizationProvider } from "./localization/LocalizationProvider";
import reportWebVitals from "./reportWebVitals";
import { setupReactQuill } from "./components/react-quill/setupReactQuill";

const { version } = packageJson;

console.log("Version", version);

setupReactQuill();

const Hubspot = React.lazy(() => import("components/Hubspot"));
const GoogleTag = React.lazy(() => import("components/GoogleTag"));

setTimeout(() => {
	import("./setupSentry").then(({ initSentry }) => initSentry());
}, 3000);

setTimeout(() => {
	import("./setupAnalytics").then(({ initAnalytics }) => initAnalytics());
}, 3000);

const InitializeApp: React.FC = () => {
	return (
		<React.StrictMode>
			<LocalizationProvider>
				<StyledEngineProvider injectFirst>
					<AppErrorBoundary>
						<React.Suspense fallback={null}>
							<Hubspot />
							<GoogleTag />
						</React.Suspense>
						<App />
					</AppErrorBoundary>
				</StyledEngineProvider>
			</LocalizationProvider>
		</React.StrictMode>
	);
};

ReactDOM.render(<InitializeApp />, document.getElementById("root"));

reportWebVitals();
